module.exports = __webpack_public_path__ + "static/Ads-Small-26d9af4bf1a909c9a7ecd5e137a4a0fa.jpg";